<template>
  <div class="wrapper">
    <common-header iconClass="create" url="riskControlTemplate" />
    <table class="table center">
      <!-- 模板基本信息 -->
      <tr>
        <th colspan="8">模板基本信息</th>
      </tr>
      <tr>
        <td>模板编号</td>
        <td>
          <el-input v-model="details.id" readonly placeholder="自动生成" />
        </td>
        <td>模板名称</td>
        <td>
          <el-input type="text" v-model="details.name" :readonly="readonly" />
        </td>
        <td>创建人</td>
        <td>
          <el-input type="text" v-model="details.name" :readonly="readonly" />
        </td>
        <td>状态</td>
        <td>
          <el-input
            v-model="details.certNo"
            :maxlength="18"
            :readonly="readonly"
            @input="value = value.replace(/[^\d|xX]/g, '')"
          />
        </td>
      </tr>
      <tr>
        <td>模板总分值</td>
        <td>
          <el-input v-model="details.deptName" readonly />
        </td>
        <!-- tudo -->
        <td>
          <p>通过分值</p>
          <p style="line-height: 16px;">（得分值>）</p>
        </td>
        <td>
          <el-input class="center_input" v-model="details.deptName" />
        </td>
        <td>
          <p>建议复议分值</p>
          <p style="line-height: 16px;">（得分值≤）</p>
        </td>
        <td>
          <el-input class="center_input" v-model="details.deptName" />
        </td>
        <td>
          <p>拒绝分值</p>
          <p style="line-height: 16px;">（得分值≤）</p>
        </td>
        <td>
          <el-input class="center_input" v-model="details.deptName" />
        </td>
      </tr>
      <tr>
        <td>备注</td>
        <td colspan="7">
          <el-input v-model="details.deptName" readonly />
        </td>
      </tr>
      <!-- 规则集选择 -->
      <tr>
        <th colspan="8">规则集选择</th>
      </tr>
      <tr>
        <td colspan="8">
          <table class="rule-box" border="1" cellspacing="0">
            <tr v-for="(item, index) in checkList" :key="index">
              <template v-for="(item1, index1) in item">
                <td :key="index1 + 'a'">
                  <el-checkbox
                    v-model="item1.bool"
                    @change="updateData"
                  ></el-checkbox>
                </td>
                <td :key="index1 + 'b'">{{ item1.value }}</td>
              </template>
            </tr>
          </table>
        </td>
      </tr>
      <!-- 规则选择 -->
      <tr>
        <th colspan="8">规则选择</th>
      </tr>
      <template v-for="(item, index) in chooseList">
        <tr :key="index + 'a0'">
          <td style="text-align:left;" colspan="8">
            <svg-icon icon-class="solid_color" class="color-primary" />
            <span style="margin-left:10px">{{ item.value }}</span>
            <span class="add add-right" @click="readonly = false">
              <span style="color:#333;">权重值合计:</span>
              {{ item.total }}</span
            >
            <span class="add" @click="readonly = false">
              <span style="color:#333;">数据来源：</span> BRZX</span
            >
          </td>
        </tr>
        <tr :key="index + 'b0'">
          <td colspan="8">
            <el-table
              ref="multipleTable"
              :data="item.childList"
              :row-key="getRowKey0"
              header-cell-class-name="dark"
              :header-cell-style="{
                'text-align': 'center',
                background: '#eaf0f5',
                color: '#333'
              }"
              :cell-style="{ 'text-align': 'center' }"
              stripe
              border
              @selection-change="handleSelectionChangePeople0(index, $event)"
            >
              <table-column
                type="selection"
                width="80"
                :reserve-selection="true"
              />

              <table-column prop="value" label="规则详情">
                <template slot-scope="scope">
                  <el-input
                    :class="!scope.row.bool ? 'font-color' : ''"
                    v-model="scope.row.value"
                    placeholder="请输入内容"
                    readonly
                  ></el-input>
                </template>
              </table-column>
              <table-column prop="weightValue" width="200" label="权量值">
                <template slot-scope="scope">
                  <el-input
                    :class="!scope.row.bool ? 'font-color' : ''"
                    @input="getNum(index)"
                    v-model="scope.row.weightValue"
                    placeholder="请输入内容"
                    :disabled="!scope.row.bool"
                    oninput="value=value.replace(/^\.+|[^\d.]/g,'')"
                  ></el-input>
                </template>
              </table-column>
            </el-table>
          </td>
        </tr>
        <!-- 关联地区 -->
      </template>
      <!-- 关联地区 -->
      <tr>
        <th colspan="8">
          关联地区
          <span class="add">选择</span>
        </th>
      </tr>
      <tr>
        <td colspan="8">
          <el-cascader
            :options="provinceList"
            :props="props"
            clearable
            ref="citySelected"
          ></el-cascader>
        </td>
      </tr>
    </table>

    <div class="action-buttons">
      <!-- <router-link
        slot="right-aside"
        to="/home/riskControlTemplate/create"
        class="button"
        >预览</router-link
      > -->
      <button @click="goPreview" class="action-button blue">
        预览
      </button>
      <button class="action-button blue">
        确认新增
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    details: {
      type: Object,
      default() {
        return {}
      },
      comment: '员工详细数据'
    },
    readonly: {
      type: Boolean,
      default: false,
      comment: '是否不能编辑'
    }
  },
  data() {
    return {
      chooseList: [],
      checkList: [
        [
          {
            id: 1,
            bool: false,
            value: '信息验证规则-自然人识别',
            total: 0,
            childList: [{ bool: false, value: '命中不良', weightValue: '' }]
          },
          {
            id: 2,
            bool: false,
            value: '信息验证规则-身份证二要素验证',
            total: 0,
            childList: [
              {
                bool: false,
                value: '身份证二要素信息比对结果不一致',
                weightValue: ''
              },
              {
                bool: false,
                value: '身份证二要素信息比对结一致',
                weightValue: ''
              },
              {
                bool: false,
                value: '身份证二要素信息无法验证',
                weightValue: ''
              }
            ]
          },
          {
            id: 3,
            bool: false,
            value: '信息验证规则_手机三要素简版_移动联通电信',
            total: 0,
            childList: [
              {
                bool: false,
                value: '手机三要素简版验证不一致',
                weightValue: ''
              },
              {
                bool: false,
                value: '手机三要素简版验证一致',
                weightValue: ''
              },
              {
                bool: false,
                value: '手机三要素简版验证查无此号',
                weightValue: ''
              }
            ]
          },
          {
            id: 4,
            bool: false,
            value: '信息验证规则-手机在网时长',
            total: 0,
            childList: [
              { bool: false, value: '手机在网时长较短', weightValue: '' },
              { bool: false, value: '手机在网时长较长', weightValue: '' },
              { bool: false, value: '手机在网时长极长', weightValue: '' },
              { bool: false, value: '手机在网时长无记录', weightValue: '' }
            ]
          }
        ],
        [
          {
            id: 5,
            bool: false,
            value: '信息验证规则-手机在网状态',
            total: 0,
            childList: [
              {
                bool: false,
                value: '手机状态异常:停机、销号等',
                weightValue: ''
              },
              { bool: false, value: '手机状态正常', weightValue: '' }
            ]
          },
          {
            id: 6,
            bool: false,
            value: '信息验证规则-手机消费档次',
            total: 0,
            childList: [
              {
                bool: false,
                value: '近期移动手机消费档次低',
                weightValue: ''
              },
              {
                bool: false,
                value: '近期联通手机消费档次低',
                weightValue: ''
              },
              {
                bool: false,
                value: '近期电信手机消费档次低',
                weightValue: ''
              }
            ]
          },
          {
            id: 7,
            bool: false,
            value: '信息验证规则-法院信息详情个人高级版',
            total: 0,
            childList: [
              {
                bool: false,
                value: '申请人在法院信息中含有案件流程且均不作为被告',
                weightValue: ''
              },
              {
                bool: false,
                value: '申请人在法院信息中含有作为被告的案件流程',
                weightValue: ''
              },
              {
                bool: false,
                value: '申请人在法院信息中含有裁判文书',
                weightValue: ''
              },
              {
                bool: false,
                value: '申请人在法院信息中含有法院公告且均不作为被告',
                weightValue: ''
              },
              {
                bool: false,
                value: '申请人在法院信息中含有作为被告的法院公告',
                weightValue: ''
              },
              {
                bool: false,
                value: '申请人在法院信息中含有开庭公告且均不作为被告',
                weightValue: ''
              },
              {
                bool: false,
                value: '申请人在法院信息中含有作为被告的开庭公告',
                weightValue: ''
              },
              {
                bool: false,
                value: '申请人在法院信息中含有曝光台',
                weightValue: ''
              },
              {
                bool: false,
                value: '申请人在法院信息中含有网贷黑名单',
                weightValue: ''
              },
              {
                bool: false,
                value: '申请人在法院信息中含有执行公告',
                weightValue: ''
              },
              {
                bool: false,
                value: '申请人在法院信息中含有失信公告案件',
                weightValue: ''
              },
              {
                bool: false,
                value: '申请人在法院信息中疑似含有案件流程且均不作为被告',
                weightValue: ''
              },
              {
                bool: false,
                value: '申请人在法院信息中疑似含有作为被告的案件流程',
                weightValue: ''
              },
              {
                bool: false,
                value: '申请人在法院信息中疑似含有裁判文书',
                weightValue: ''
              },
              {
                bool: false,
                value: '申请人在法院信息中疑似含有法院公告且均不作为被告',
                weightValue: ''
              },
              {
                bool: false,
                value: '申请人在法院信息中疑似含有作为被告的法院公告',
                weightValue: ''
              },
              {
                bool: false,
                value: '申请人在法院信息中疑似含有开庭公告且均不作为被告',
                weightValue: ''
              },
              {
                bool: false,
                value: '申请人在法院信息中疑似含有作为被告的开庭公告',
                weightValue: ''
              },
              {
                bool: false,
                value: '申请人在法院信息中疑似含有曝光台',
                weightValue: ''
              },
              {
                bool: false,
                value: '申请人在法院信息中疑似含有网贷黑名单',
                weightValue: ''
              },
              {
                bool: false,
                value: '申请人在法院信息中疑似含有执行公告',
                weightValue: ''
              },
              {
                bool: false,
                value: '申请人在法院信息中疑似含有失信公告',
                weightValue: ''
              }
            ]
          },
          {
            id: 8,
            bool: false,
            value: '反欺诈规则-法院被执行人',
            total: 0,
            childList: [
              { bool: false, value: '法院失信人', weightValue: '' },
              { bool: false, value: '法院被执行人', weightValue: '' },
              {
                bool: false,
                value: '曾为法院被执行人但已全部结案',
                weightValue: ''
              },
              {
                bool: false,
                value: '法院失信人已退出失信名单',
                weightValue: ''
              }
            ]
          }
        ],
        [
          {
            id: 9,
            bool: false,
            value: '反欺诈规则-法院被执行人高级版',
            total: 0,
            childList: [
              {
                bool: false,
                value: '为法院失信被执行人且存在未履行的失信案件',
                weightValue: ''
              },
              {
                bool: false,
                value: '为法院被执行人且未全部结案',
                weightValue: ''
              },
              {
                bool: false,
                value: '曾为法院被执行人但已全部结案',
                weightValue: ''
              },
              {
                bool: false,
                value: '为法院失信被执行人，但所有案件均已履行',
                weightValue: ''
              },
              { bool: false, value: '命中曝光台', weightValue: '' }
            ]
          },
          {
            id: 10,
            bool: false,
            value: '反欺诈规则-法院裁判文书',
            total: 0,
            weightValue: '',
            childList: [
              {
                bool: false,
                value: '查询人相关案件败诉',
                weightValue: ''
              },
              {
                bool: false,
                value: '查询人的相关案件未败诉但存在欺诈风险',
                weightValue: ''
              }
            ]
          },
          {
            id: 11,
            bool: false,
            value: '反欺诈规则-法院被执行人限高版',
            total: 0,
            childList: [
              {
                bool: false,
                value: '为法院失信被执行人',
                weightValue: ''
              },
              { bool: false, value: '为法院限高被执行人', weightValue: '' }
            ]
          },
          {
            id: 12,
            bool: false,
            value: '反欺诈规则-特殊名单验证',
            total: 0,
            childList: [
              {
                bool: false,
                value: '近两年命中法院失信人',
                weightValue: ''
              },
              { bool: false, value: '近两年命中法院失信人', weightValue: '' },
              { bool: false, value: '两年前命中法院失信人', weightValue: '' },
              {
                bool: false,
                value: '近两年命中法院被执行人',
                weightValue: ''
              },
              {
                bool: false,
                value: '两年前命中法院被执行人',
                weightValue: ''
              },
              {
                bool: false,
                value: '近两年本人命中银行高风险',
                weightValue: ''
              },
              {
                bool: false,
                value: '两年前本人命中银行高风险',
                weightValue: ''
              },
              {
                bool: false,
                value: '近两年本人命中银行中风险',
                weightValue: ''
              },
              {
                bool: false,
                value: '两年前本人命中银行中风险',
                weightValue: ''
              },
              {
                bool: false,
                value: '近两年本人命中银行拒绝',
                weightValue: ''
              },
              {
                bool: false,
                value: '两年前本人命中银行拒绝',
                weightValue: ''
              },
              {
                bool: false,
                value: '近两年本人命中银行资信不佳',
                weightValue: ''
              },
              {
                bool: false,
                value: '两年前本人命中银行资信不佳',
                weightValue: ''
              },
              {
                bool: false,
                value: '近两年本人命中银行一般风险',
                weightValue: ''
              },
              {
                bool: false,
                value: '两年前本人命中银行一般风险',
                weightValue: ''
              },
              {
                bool: false,
                value: '近两年本人命中非银高风险',
                weightValue: ''
              },
              {
                bool: false,
                value: '两年前本人命中非银高风险',
                weightValue: ''
              },
              {
                bool: false,
                value: '近两年本人命中非银中风险',
                weightValue: ''
              },
              {
                bool: false,
                value: '两年前本人命中非银中风险',
                weightValue: ''
              },
              {
                bool: false,
                value: '近两年本人命中非银一般风险',
                weightValue: ''
              },
              {
                bool: false,
                value: '两年前本人命中非银一般风险',
                weightValue: ''
              },
              {
                bool: false,
                value: '近两年本人命中非银拒绝',
                weightValue: ''
              },
              {
                bool: false,
                value: '两年前本人命中非银拒绝',
                weightValue: ''
              },
              {
                bool: false,
                value: '近两年本人命中非银资信不佳',
                weightValue: ''
              },
              {
                bool: false,
                value: '两年前本人命中非银资信不佳',
                weightValue: ''
              },
              { bool: false, value: '关联人命中银行高风险', weightValue: '' },
              { bool: false, value: '关联人命中银行中风险', weightValue: '' },
              { bool: false, value: '关联人命中银行拒绝', weightValue: '' },
              {
                bool: false,
                value: '关联人命中银行资信不佳',
                weightValue: ''
              },
              {
                bool: false,
                value: '关联人命中银行一般风险',
                weightValue: ''
              },
              { bool: false, value: '关联人命中非银高风险', weightValue: '' },
              { bool: false, value: '关联人命中非银中风险', weightValue: '' },
              {
                bool: false,
                value: '关联人命中非银一般风险',
                weightValue: ''
              },
              { bool: false, value: '关联人命中非银拒绝', weightValue: '' },
              {
                bool: false,
                value: '关联人命中非银资信不佳',
                weightValue: ''
              },
              {
                bool: false,
                value: '本人命中银行中风险次数较多',
                weightValue: ''
              },
              {
                bool: false,
                value: '本人命中银行拒绝次数较多',
                weightValue: ''
              },
              {
                bool: false,
                value: '本人命中银行资信不佳次数较多',
                weightValue: ''
              },
              {
                bool: false,
                value: '本人命中银行一般风险次数较多',
                weightValue: ''
              },
              {
                bool: false,
                value: '本人命中非银中风险次数较多',
                weightValue: ''
              },
              {
                bool: false,
                value: '本人命中非银一般风险次数较多',
                weightValue: ''
              },
              {
                bool: false,
                value: '本人命中非银拒绝次数较多',
                weightValue: ''
              },
              {
                bool: false,
                value: '本人命中非银资信不佳次数较多',
                weightValue: ''
              },
              {
                bool: false,
                value: '关联人命中银行中风险次数较多',
                weightValue: ''
              },
              {
                bool: false,
                value: '关联人命中银行拒绝次数较多',
                weightValue: ''
              },
              {
                bool: false,
                value: '关联人命中银行资信不佳次数较多',
                weightValue: ''
              },
              {
                bool: false,
                value: '关联人命中银行一般风险次数较多',
                weightValue: ''
              },
              {
                bool: false,
                value: '关联人命中非银中风险次数较多',
                weightValue: ''
              },
              {
                bool: false,
                value: '关联人命中非银一般风险次数较多',
                weightValue: ''
              },
              {
                bool: false,
                value: '关联人命中非银拒绝次数较多',
                weightValue: ''
              },
              {
                bool: false,
                value: '关联人命中非银资信不佳次数较多',
                weightValue: ''
              }
            ]
          }
        ],
        [
          {
            id: 13,
            bool: false,
            value: '反欺诈规则-借贷意向验证-通用',
            total: 0,
            childList: [
              {
                bool: false,
                value: '在非银机构申请次数极多',
                weightValue: ''
              },
              {
                bool: false,
                value: '在非银机构申请次数较多',
                weightValue: ''
              },
              {
                bool: false,
                value: '在银行机构申请次数极多',
                weightValue: ''
              },
              {
                bool: false,
                value: '在银行机构申请次数较多',
                weightValue: ''
              }
            ]
          },
          {
            id: 14,
            bool: false,
            value: '反欺诈规则-借贷风险勘测',
            total: 0,
            childList: [
              {
                bool: false,
                value: '近期申请超利贷机构极为频繁',
                weightValue: ''
              },
              {
                bool: false,
                value: '长期申请超利贷机构极为频繁',
                weightValue: ''
              },
              {
                bool: false,
                value: '历史申请超利贷机构极为频繁',
                weightValue: ''
              },
              {
                bool: false,
                value: '近期申请超利贷机构较为频繁',
                weightValue: ''
              },
              {
                bool: false,
                value: '长期申请超利贷机构较为频繁',
                weightValue: ''
              },
              {
                bool: false,
                value: '历史申请超利贷机构较为频繁',
                weightValue: ''
              }
            ]
          },
          {
            id: 15,
            bool: false,
            value: '反欺诈规则-借贷行为验证-高级',
            total: 0,
            childList: [
              {
                bool: false,
                value: '预测近期新增核准次数极多',
                weightValue: ''
              },
              {
                bool: false,
                value: '预测近期新增核准次数较多',
                weightValue: ''
              },
              {
                bool: false,
                value: '预测近期新增核准机构数极多',
                weightValue: ''
              },
              {
                bool: false,
                value: '预测近期新增核准机构数较多',
                weightValue: ''
              },
              {
                bool: false,
                value: '预测近期新增核准借贷等级极高',
                weightValue: ''
              },
              {
                bool: false,
                value: '预测近期新增核准借贷等级较高',
                weightValue: ''
              },
              {
                bool: false,
                value: '预测过去2年内新增核准次数极多',
                weightValue: ''
              },
              {
                bool: false,
                value: '预测过去2年内新增核准次数较多',
                weightValue: ''
              },
              {
                bool: false,
                value: '预测过去2年内新增核准机构数极多',
                weightValue: ''
              },
              {
                bool: false,
                value: '预测过去2年内新增核准机构数较多',
                weightValue: ''
              },
              {
                bool: false,
                value: '预测过去2年内新增核准借贷等级极高',
                weightValue: ''
              },
              {
                bool: false,
                value: '预测过去2年内新增核准借贷等级较高',
                weightValue: ''
              }
            ]
          },
          {
            id: 16,
            bool: false,
            value: '反欺诈规则-申请信息评估-通用-高级',
            total: 0,
            childList: [
              {
                bool: false,
                value: '手机号关联查询可疑信息极多',
                weightValue: ''
              },
              {
                bool: false,
                value: '手机号关联查询可疑信息较多',
                weightValue: ''
              },
              {
                bool: false,
                value: '身份证关联查询可疑信息极多',
                weightValue: ''
              },
              {
                bool: false,
                value: '身份证关联查询可疑信息较多',
                weightValue: ''
              }
            ]
          }
        ],
        [
          {
            id: 17,
            bool: false,
            value: '反欺诈规则-团伙欺诈排查（通用版）',
            total: 0,
            childList: [
              { bool: false, value: '欺诈团伙等级极高', weightValue: '' },
              { bool: false, value: '欺诈团伙等级较高', weightValue: '' }
            ]
          },
          {
            id: 18,
            bool: false,
            value: '反欺诈规则-偿债压力指数',
            total: 0,
            childList: [
              { bool: false, value: '偿债压力极高', weightValue: '' },
              { bool: false, value: '欺诈团伙等级较高', weightValue: '' }
            ]
          }
        ]
      ],
      props: { multiple: true },
      provinceList: []
    }
  },

  methods: {
    // 规则集选择 => 选中的数组
    updateData() {
      let arr = []
      this.checkList.map((item, index) => {
        item.map((item1, index1) => {
          if (item1.bool) {
            arr.push(item1)
          }
        })
      })
      this.chooseList = arr
    },
    getRowKey0(row) {
      return row.value
    },
    handleSelectionChangePeople0(index, rows) {
      this.chooseList.map((item, index) => {
        item.childList.map((item1, index1) => {
          item1.bool = false
          rows.map(item2 => {
            if (item1.value == item2.value) {
              this.chooseList[index].childList[index1].bool = true
            }
          })
        })
      })

      this.getNum(index)
    },

    getRowKey(row) {
      return row.date
    },
    handleSelectionChangePeople(rows) {
      console.log(rows)
    },

    getNum(index) {
      let tempTotal = 0
      this.chooseList[index].childList.map(item => {
        if (item.bool) {
          tempTotal = tempTotal + Number(item.weightValue)
        }
      })

      this.chooseList[index].total = tempTotal
    },

    // 获取作业区域
    async getWorkMenu() {
      let { dispatch } = this.$store
      let dispatchEvent = 'T4/channelQuery/getWorkMenu'
      let res = await dispatch(dispatchEvent)
      let list = []
      res.map(item => {
        let arr = []
        item.cityList.map(v => {
          arr.push({
            value: v.id,
            label: v.name,
            parentId: v.parentId
          })
        })
        list.push({
          value: item.id,
          label: item.name,
          children: arr
        })
      })
      this.provinceList = list
      console.log(this.provinceList)
    },

    // 预览页面
    goPreview() {
      this.$router.push({
        path: `/home/riskControlTemplate/preview`,
        query: { idList: this.chooseList }
      })
    }
  },

  created() {
    this.getWorkMenu()
  }
}
</script>

<style lang="scss" scoped>
@import '@/css/Common/tableList.scss';
@import '@/css/Common/detailsTable.scss';
.rule-box {
  border: 1px solid #f5f7f9;

  tr td:nth-child(even) {
    text-align: center;
  }

  tr td:nth-child(odd) {
    width: 60px;
    text-align: center;
    background: #fff;
  }
}

.add-right {
  right: 200px;
}
.el-cascader {
  width: 100%;
  height: 100px;
  margin: auto 0;
}

.center_input {
  display: block;
  margin-top: 10px;
}

/deep/ .table input,
.table .el-input__inner,
.table.el-textarea__inner {
  text-align: center;
}

.font-color /deep/.el-input__inner {
  color: #ccc !important;
}

.el-popper {
  left: 50%;
}
.el-popper[x-placement^='bottom'] {
  left: 50%;
}
</style>